/* Litmus marquee — pause control for the trust bar ticker (WCAG 2.2.2).
   The ticker itself is pure CSS; without this script it still pauses on
   hover and focus, and the button stays hidden.

   On phones with reduced motion the ticker becomes a sideways-scrolling row
   (section-litmus-trust-bar.css). While that is the case the viewport takes a
   tab stop and a name, so keyboard users can scroll it (WCAG 2.1.1). */
if (!customElements.get('litmus-marquee')) {
  customElements.define(
    'litmus-marquee',
    class LitmusMarquee extends HTMLElement {
      connectedCallback() {
        this.bindScrollRow();

        const toggle = this.querySelector('[data-marquee-toggle]');
        if (!toggle || toggle.dataset.bound) return;
        toggle.dataset.bound = 'true';
        toggle.hidden = false;
        toggle.addEventListener('click', () => {
          const paused = !this.hasAttribute('data-paused');
          this.toggleAttribute('data-paused', paused);
          toggle.setAttribute('aria-pressed', String(paused));
        });
      }

      bindScrollRow() {
        const viewport = this.querySelector('.litmus-trust-bar__viewport');
        const list = this.querySelector('.litmus-trust-bar__list:not(.litmus-trust-bar__list--clone)');
        /* The scroll layout already has a tab stop in the Liquid. */
        if (!viewport || viewport.dataset.scrollRow || viewport.hasAttribute('tabindex') || !window.matchMedia) return;
        viewport.dataset.scrollRow = 'bound';

        const scrollRow = window.matchMedia('(max-width: 749px) and (prefers-reduced-motion: reduce)');
        const update = () => {
          if (scrollRow.matches) {
            viewport.setAttribute('tabindex', '0');
            viewport.setAttribute('role', 'region');
            if (list && list.getAttribute('aria-label')) viewport.setAttribute('aria-label', list.getAttribute('aria-label'));
          } else {
            viewport.removeAttribute('tabindex');
            viewport.removeAttribute('role');
            viewport.removeAttribute('aria-label');
          }
        };
        update();
        if (scrollRow.addEventListener) scrollRow.addEventListener('change', update);
      }
    }
  );
}
